import request from './api'
/**
 *    考勤  任务库api
 * */

/**
 *  Author by zyp. on 202.6.17
 */

// // 获取考勤列表
export const getWorkAttendanceList = (id,params, opts) =>
    request('/api-data/staAttence/teacher/attence/getAttenceList'+id, params, {
        ...opts,
        // method: 'post'
    });
// // 获取考勤次数
export const getWorkAttendanceCountNum = (id,params, opts) =>
    request('/api-data/staAttence/teacher/attence/getAttenceCountNum'+id, params, {
        ...opts,
        // method: 'post'
    });
// // 删除考勤
export const delWorkAttendance = (id,params, opts) =>
    request('/api-data/staAttence/teacher/attence/delAttence'+id, params, {
        ...opts,
        method: 'delete'
    });

// // 增加考勤
export const addWorkAttendance = (id,params, opts) =>
    request('/api-data/staAttence/teacher/attence/insertAttence'+id, params, {
        ...opts,
        method: 'post'
    });
// // 查询考勤
export const selectWorkAttendance = (id,params, opts) =>
    request('/api-data/staAttence/teacher/attence/selectAttence'+id, params, {
        ...opts,
        method: 'post'
    });
// // 查询考勤详情
export const selectWorkAttendanceViewDetail = (id,params, opts) =>
    request('/api-data/staAttence/teacher/attence/viewDetail'+id, params, {
        ...opts,
        method: 'post'
    });
// // 查询考勤详情搜索
export const selectWorkAttendanceViewDetailSearch = (id,params, opts) =>
    request('/api-data/staAttence/teacher/attence/viewDetail/getStuByNameOrNum'+id, params, {
        ...opts,
        method: 'post'
    });
// // 老师考勤编辑
export const selectWorkAttendancereviseh = (id,params, opts) =>
    request('/api-data/staAttence/teacher/attence/updateAttenceList'+id, params, {
        ...opts,
        method: 'post'
    });
// // 学生考勤列表
export const getStudentAttenceList = (id,params, opts) =>
    request('/api-data/StaAttenceUser/student/attence/getAttenceUser'+id, params, {
        ...opts,
        // method: 'post'
    });
// // 学生考勤次数
export const getStudentAttenceNum = (id,params, opts) =>
    request('/api-data/StaAttenceUser/student/attence/getAttenceCountNum'+id, params, {
        ...opts,
        // method: 'post'
    });
// // 学生点击签到
export const studentAttence = (id,params, opts) =>
    request('/api-data/StaAttenceUser/student/attence/stuAttence'+id, params, {
        ...opts,
        method: 'post'
    });




// WEBPACK FOOTER //
// ./src/api/workAttendanceApi.js